import conference from './reducers/conference'
import breakoutRooms from './reducers/breakoutRooms'
import { combineReducers } from 'redux'

export default combineReducers({
  conference,
  breakoutRooms,
})
